export default "__VITE_ASSET__CY1SD7M7__"